export default __webpack_public_path__ + "static/debugging-808319acd112a13c5402f92336d5237d.svg";